export default __webpack_public_path__ + "example.ac81b41.png";